export default function Features() {
  const features = [
    {
      icon: 'ri-gamepad-line',
      title: 'Classic Arcade + Modern Favorites',
      description: 'From Pac-Man to pinball, we\'ve got all your favorite games from the golden age and beyond.'
    },
    {
      icon: 'ri-goblet-line',
      title: 'Craft Cocktails & Local Beer',
      description: 'Signature drinks and carefully curated local brews to keep the good times flowing.'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Weekly Events & Tournaments',
      description: 'Trivia nights, throwback tournaments, and special events every week. Never a dull moment.'
    },
    {
      icon: 'ri-team-line',
      title: 'Private Parties + Group Packages',
      description: 'Level up your next celebration with exclusive arcade party packages for groups of all sizes.'
    }
  ];

  return (
    <section id="features" className="relative py-24 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628] to-[#0d1f3c]"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-pink-400 mb-4">
            What Makes Us Special
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-pink-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-[#0d1f3c] to-[#0a1628] rounded-xl p-8 border border-cyan-500/20 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(34,211,238,0.3)] hover:-translate-y-2"
            >
              {/* Pixel corner accents */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-cyan-400"></div>
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-cyan-400"></div>
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-pink-400"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-pink-400"></div>

              <div className="w-16 h-16 flex items-center justify-center mb-6 bg-gradient-to-br from-cyan-500/20 to-pink-500/20 rounded-lg group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-4xl text-cyan-400 group-hover:text-pink-400 transition-colors duration-300`}></i>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors duration-300">
                {feature.title}
              </h3>

              <p className="text-gray-400 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
